module.exports = __webpack_public_path__ + "288c18714ec61c48a0feaacd2703413c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/TopMenu/icons/phone.svg
// module id = 1561
// module chunks = 0